import styled from 'styled-components'
import colors from 'theme/colors'

export const LoadingScreen = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: relative;
`

export const LoadingErrorScreen = styled.div`
  align-items: center;
  background-color: ${colors['gray7']};
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 78px);
  width: 100%;
  position: relative;
`

export const LoadingErrorContent = styled.div`
  text-align: center;
  color: ${colors['gray4']};

  > button {
    width: 150px;
  }
`

export const LoadingErrorImg = styled.img`
  width: 100%;
  max-width: 300px;
`
